import React from "react";
import { connect } from "react-redux";
import Button from "@mui/material/Button";
import Telegram from "./assets/Telegram.png";
import TelegramWhite from "./assets/Telegram-White.png";

const TradeAlertsSidebar = ({ themeMode, telegramUrl }) => {
  return (
    <div className="trade-alerts-container">
      <div className="description-blocks mw-n mt-0 br-10">
        <span className="title">Trade Alerts and Signals</span>
        <div className="image-title-description">
          <img
            src={themeMode === "light" ? Telegram : TelegramWhite}
            className="bell"
            alt="Telegram"
          />
          <div className="title-description">
            <span className="inner-title">Join the Community</span>
            <span className="inner-description">
              Dane provides profitable trade alerts in our exclusive telegram
              group. Join the community and start making smarter trades.
            </span>
          </div>
        </div>
        <Button
          onClick={() => window.open(telegramUrl, "_blank")}
          className="supports-widget-item-button"
        >
          Join Telegram
        </Button>
      </div>
    </div>
  );
};

const stateToProps = (state) => ({
  themeMode: state.themeMode.themeMode,
});

export default connect(stateToProps, null)(TradeAlertsSidebar);
